import { Tooltip } from 'antd';
import React from 'react';
import TipContent, { tipToText, type TipText } from './TipContent';

interface IconTipProps {
  /** Tooltip content — plain text, or a heading with short lines. Also the accessible name. */
  title: string | TipText;
  children: React.ReactNode;
}

/**
 * An icon with a tooltip. The icon sits in a focusable span because antd's
 * Tooltip needs a DOM child it can hold a ref to — react-icons components
 * don't forward refs, so a bare icon leaves the tooltip unable to find its
 * anchor (it flashes at the corner of the page and closes).
 */
const IconTip: React.FC<IconTipProps> = ({ title, children }) => (
  <Tooltip title={<TipContent tip={title} />}>
    <span
      role="img"
      aria-label={tipToText(title)}
      tabIndex={0}
      className="inline-flex cursor-help items-center text-gray-dark"
    >
      {children}
    </span>
  </Tooltip>
);

export default IconTip;
